import { useFormContext, useWatch } from 'react-hook-form';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { ContributionPeriodDTO } from '../../../../../../api/useAccountsQuery';
import {
  ROTH_ACCOUNT_TYPES,
  EMPLOYER_MATCH_ACCOUNT_TYPES,
  FormFields,
} from '../../AccountForm.meta';
import { AccountType } from '../../../../../../api/useAccountsOptionsQuery';

export const useContribution = () => {
  const { control } = useFormContext<FormFields>();

  const accountType = useWatch({ name: 'bankAccount.AccountType', control });

  const {
    options: {
      AccountTypeOptions,
      SimpleIraEmployerMatchTypeOptions,
      EmployerMatchOptions,
      EmployerLimitOptions: employerLimitOptions,
    },
  } = useAccountFormContext();

  if (accountType === null || accountType === undefined) {
    throw new Error('Account type not found');
  }

  const accountTypeOptions = AccountTypeOptions.find(option => option.AccountType === accountType);

  if (!accountTypeOptions) {
    throw new Error('Account type options not found');
  }

  const {
    CanEmployeeMaxContribution: canEmployeeMaxContribution,
    HasContributionPeriodOption: hasContributionPeriodOption,
    HasContributionPercentOption: hasContributionPercentOption,
    ContributionTaxStatuses,
    EmployerContributionTaxStatuses,
  } = accountTypeOptions;

  const contributionTaxStatusOptions = ContributionTaxStatuses.map(({ Value, Label }) => ({
    value: Value,
    label: Label,
  }));

  const employerContributionTaxStatusesOptions = EmployerContributionTaxStatuses.map(
    ({ Value, Label }) => ({
      value: Value,
      label: Label,
    }),
  );

  const isRothAccount = ROTH_ACCOUNT_TYPES.includes(accountType);

  const hasEmployerMatch = EMPLOYER_MATCH_ACCOUNT_TYPES.includes(accountType);

  const isSimpleIRA = accountType === AccountType.SimpleIra;

  return {
    canEmployeeMaxContribution,
    hasContributionPeriodOption,
    hasContributionPercentOption,
    contributionTaxStatusOptions,
    contributionPeriodOptions: [
      {
        label: ContributionPeriodDTO[ContributionPeriodDTO.Monthly],
        value: ContributionPeriodDTO.Monthly,
      },
      {
        label: ContributionPeriodDTO[ContributionPeriodDTO.Annually],
        value: ContributionPeriodDTO.Annually,
      },
    ],
    employerContributionTaxStatusesOptions,
    employerMatchOptions: isSimpleIRA ? SimpleIraEmployerMatchTypeOptions : EmployerMatchOptions,
    employerLimitOptions,
    isRothAccount,
    hasEmployerMatch,
    isSimpleIRA,
  };
};
